var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ParticularReconciliation"},[_c('DtList',{attrs:{"orderId":_vm.orderId},on:{"priceList":_vm.priceList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }